import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FormattedHTMLMessage } from 'react-intl'
import { selectCustomerSupportEmail } from 'services/bootup/selectors'

const mapStateToProps = (state) => ({
  defaultEmail: selectCustomerSupportEmail(state),
})

function ContactSupportCopy (props) {
  return (
    <FormattedHTMLMessage
      id='privacy_center.help.email_support'
      defaultMessage="<p>Please contact {email} for further support.</p>"
      values={ { email: props.email || props.defaultEmail } } />
  )
}

ContactSupportCopy.propTypes = {
  defaultEmail: PropTypes.string,
  email: PropTypes.string,
}

export default connect(mapStateToProps, {})(ContactSupportCopy)
